// import request from "@/utils/axios"
import request from "axios";
import Qs from "qs";
export function getData(url, type, data) {
  return request({
    url: "/admin" + url,
    method: type,
    params: data
  });
}
export function getDatas(url, type, data) {
  return request({
    url: "/admin" + url + data,
    method: type
  });
}
export function putData(url, type, data) {
  return request({
    url: "/admin" + url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    method: type,
    data: data
  });
}
export function loginData(url, type, data) {
  return request({
    headers: {
      Authorization: "Basic dGVzdDp0ZXN0",
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: "/admin" + url + Qs.stringify(data),
    method: type
  });
}
export function postData(url, type, data) {
  return request({
    url: "/admin" + url,
    method: type,
    data: data
  });
}
export function deleteData(url, type, data) {
  return request({
    url: "/admin" + url,
    method: type,
    params: data
  });
}
export function deleteDatas(url, type, data) {
  return request({
    url: "/admin" + url + data,
    method: type
  });
}

export function getDatatoShow(url, type, data) {
  return request({
    url: "/admin" + url,
    method: type,
    params: data,
    responseType: "arraybuffer"
  });
}
export function exportData(url, type, data) {
  return request({
    url: "/admin" + url,
    responseType: "blob",
    method: type,
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/request/all.js